import React from 'react';
import { IconButton, MenuItem } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../hooks/useTheme';

interface ThemeToggleProps {
  variant?: 'icon' | 'menuItem';
  onAfterToggle?: () => void;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  variant = 'icon',
  onAfterToggle,
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  const handleToggle = () => {
    toggleTheme();
    onAfterToggle?.();
  };

  if (variant === 'menuItem') {
    return (
      <MenuItem onClick={handleToggle}>
        {isDarkMode ? <Brightness7 sx={{ mr: 2 }} /> : <Brightness4 sx={{ mr: 2 }} />}
        {isDarkMode ? 'Light Mode' : 'Dark Mode'}
      </MenuItem>
    );
  }

  return (
    <IconButton
      onClick={handleToggle}
      color="primary"
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? <Brightness7 /> : <Brightness4 />}
    </IconButton>
  );
};
